<select #langSelect (change)="selectLang(langSelect.value)">
  <option
    *ngFor="let lang of translate.getLangs()"
    [value]="lang"
    [attr.selected]="lang === translate.currentLang ? '' : null"
  >
    {{ lang }}
  </option>
</select>
